import { render, staticRenderFns } from "./InvestmentPlanTotal.vue?vue&type=template&id=38099472&"
import script from "./InvestmentPlanTotal.vue?vue&type=script&lang=js&"
export * from "./InvestmentPlanTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports